import { IButtonStyles } from "@fluentui/react";
import {
  concatStyleSets,
  HighContrastSelector,
  IRawStyle,
  ITheme,
} from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import { AppGalleryStyles, getAppGalleryStyles } from "@1js/acui-gallery";

export const defaultDimensions = {
  expandedGalleryButtonWidth: 40,
  expandedGalleryButtonHeight: 40,
  borderWidth: 4,
};

function getDisabledGalleryButtonStyles(): IRawStyle {
  return {
    border: "none",
    selectors: {
      [HighContrastSelector]: {
        border: "1px solid GrayText",
      },
    },
  };
}

const characterGalleryButtonInExpandedStyles: IButtonStyles = {
  root: {
    height: defaultDimensions.expandedGalleryButtonHeight,
    width: defaultDimensions.expandedGalleryButtonWidth,
    padding: "0",
    fontSize: 24,
    selectors: {
      ":focus": {
        borderWidth: defaultDimensions.borderWidth,
      },
    },
  },
  rootDisabled: {
    pointerEvents: "auto",
    selectors: {
      ":hover": getDisabledGalleryButtonStyles(),
      ":active": getDisabledGalleryButtonStyles(),
    },
  },
};

export const getCustomizedCharacterCodeGalleryStyles = memoizeFunction(
  (customStyles?: Partial<AppGalleryStyles>): Partial<AppGalleryStyles> => {
    return {
      ...customStyles,
      galleryButtonInExpanded: concatStyleSets(
        characterGalleryButtonInExpandedStyles,
        customStyles && customStyles.galleryButtonInExpanded
      ),
    };
  }
);

export const getCharacterGalleryStyles = memoizeFunction(
  (
    theme: ITheme,
    customStyles?: Partial<AppGalleryStyles>
  ): AppGalleryStyles => {
    return getAppGalleryStyles(
      theme,
      getCustomizedCharacterCodeGalleryStyles(customStyles)
    );
  }
);
